import { type Store } from '@prisma/client'
import { Text } from '#app/components/ui/typography.tsx'
import { Country } from '#app/enums/country.ts'
import { StoreType } from '#app/enums/store-type.ts'
import { useLocale } from '#app/utils/i18n.tsx'
import { type SerializeFrom } from '#types/common.ts'

export function StoreTitle({ store }: { store: SerializeFrom<Store> }) {
	const locale = useLocale()

	return (
		<Text
			as={'p'}
			size={'h5'}
			type={'serif'}
			weight={'light'}
			className={'uppercase'}
		>
			{StoreType.getByCode(store.type)?.labels[locale]}{' '}
			{StoreType.getByCode(store.type) === StoreType.GALLERY
				? (store.city ?? '')
				: ''}
		</Text>
	)
}

export function StoreDetails({ store }: { store: SerializeFrom<Store> }) {
	const locale = useLocale()

	return (
		<div>
			<div className={'flex flex-wrap items-baseline gap-x-2'}>
				{store.address && (
					<Text as={'p'} weight={'light'}>
						{store.address}
					</Text>
				)}
				{store.zip && (
					<Text as={'p'} weight={'light'}>
						{store.zip}
					</Text>
				)}
			</div>
			<div className={'flex flex-wrap items-baseline gap-x-2'}>
				{store.city && (
					<Text as={'p'} weight={'light'}>
						{store.city}
					</Text>
				)}
				{store.province && (
					<Text as={'p'} weight={'light'}>
						({store.province})
					</Text>
				)}
				{store.country && (
					<Text as={'p'} weight={'light'}>
						– {Country.getByCode(store.country)?.labels[locale]}
					</Text>
				)}
			</div>
			<div>
				{store.phone && (
					<Text as={'p'} weight={'light'}>
						{store.phone}
					</Text>
				)}
				{store.email && (
					<Text as={'p'} weight={'light'}>
						{store.email}
					</Text>
				)}
			</div>
		</div>
	)
}
